<template>
    <div class="form-group form-group--icons hidden-xs">
        <div class="view-mode-switcher js-viewModeListGridSwitcher" data-target="target-list-1">
            <div class="mode-icon" data-mode="list" :class="{active : isList}">
                <i class="icon-list-mode" @click="$emit('mode-change', 'list')"></i>
            </div>
            <div class="mode-icon" data-mode="grid" :class="{active : !isList}">
                <i class="icon-grid-mode" @click="$emit('mode-change', 'grid')"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ViewModeSwitch",
        props: {
            isList: Boolean
        }
    }
</script>

<style scoped>

</style>